module.exports = __webpack_public_path__ + "static/media/food09.6eb10bde.jpg";